import {Lang, Language} from 'yougile-lang'
import {Time} from 'yougile-util'
import {getNextScheduledTime} from './get-next-scheduled-time'
import {Schedule, toLocalSchedule} from './schedule'

export const getNextScheduledReadable = (
  schedule: Schedule,
  latest = Time.now(),
  lang?: Language
): string => {
  const timestamp = getNextScheduledTime(schedule, latest)
  if (!timestamp) {
    return ''
  }

  const msg = Lang.getMessages(lang ?? Lang.getLang())
  const local = toLocalSchedule(schedule)
  const zz = (n: number) => ('00' + n).slice(-2)
  const time = [local.hour, local.minute].map(zz).join(':')
  const atTime = msg.repeat.atTime(time)

  const d = new Date()
  d.setHours(23)
  d.setMinutes(59)
  d.setSeconds(59)
  const endOfToday = Time.toTimestamp(d)

  if (timestamp < endOfToday) {
    return msg.repeat.today + ' ' + atTime
  }

  if (timestamp < endOfToday + Time.day) {
    return msg.repeat.tomorrow + ' ' + atTime
  }

  return (
    Time.formatDate(timestamp, {alwaysWithYear: true, fullMonth: true}) +
    ' ' +
    atTime
  )
}

export const getNextTwoScheduledReadable = (
  schedule: Schedule | undefined,
  lang?: Language
): string => {
  if (!schedule) {
    return ''
  }

  const timestamp = getNextScheduledTime(schedule, Time.now())
  if (!timestamp) {
    return ''
  }
  const time1 = getNextScheduledReadable(schedule, undefined, lang)
  const time2 = getNextScheduledReadable(schedule, timestamp, lang)

  return `${time1}, ${time2}, ...`
}
